import { render, staticRenderFns } from "./PrintSupportsExports.vue?vue&type=template&id=24cb47d4&"
import script from "./PrintSupportsExports.vue?vue&type=script&lang=js&"
export * from "./PrintSupportsExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports